import { useContext } from 'react'
import {
  PermissionContextProps,
  PermissionsContext,
} from '../containers/contexts/permissions/PermissionsContext'

const usePermissions = () => {
  const { permissions, hasPermission, permissionsLoading } = useContext(
    PermissionsContext
  ) as PermissionContextProps
  return { permissions, hasPermission, permissionsLoading }
}

export default usePermissions
